export const PRIVILEGES = {
    CREATE_SHORTLINKS: 'CREATE_SHORTLINKS_PRIVILEGE',
    CREATE_PERSONALIZED_BUTTON: 'CREATE_PERSONALIZED_BUTTON_PRIVILEGE',
    VIBER_CAMPAIGN_READ_PRIVILEGE: 'VIBER_CAMPAIGN_READ_PRIVILEGE',
    VIBER_CAMPAIGN_CREATE_PRIVILEGE: 'VIBER_CAMPAIGN_CREATE_PRIVILEGE',
    VIBER_CAMPAIGN_DELETE_PRIVILEGE: 'VIBER_CAMPAIGN_DELETE_PRIVILEGE',
    VIBER_CAMPAIGN_UPDATE_PRIVILEGE: 'VIBER_CAMPAIGN_UPDATE_PRIVILEGE',
    SMS_CAMPAIGN_READ_PRIVILEGE: 'SMS_CAMPAIGN_READ_PRIVILEGE',
    SMS_CAMPAIGN_CREATE_PRIVILEGE: 'SMS_CAMPAIGN_CREATE_PRIVILEGE',
    SMS_CAMPAIGN_DELETE_PRIVILEGE: 'SMS_CAMPAIGN_DELETE_PRIVILEGE',
    SMS_CAMPAIGN_UPDATE_PRIVILEGE: 'SMS_CAMPAIGN_UPDATE_PRIVILEGE',
    USER_READ_PRIVILEGE: 'USER_READ_PRIVILEGE',
    USER_CREATE_PRIVILEGE: 'USER_CREATE_PRIVILEGE',
    USER_UPDATE_PRIVILEGE: 'USER_UPDATE_PRIVILEGE',
    USER_DELETE_PRIVILEGE: 'USER_DELETE_PRIVILEGE',
    RECURRING_VIBER_CAMPAIGN_READ_PRIVILEGE: 'RECURRING_VIBER_CAMPAIGN_READ_PRIVILEGE',
    RECURRING_VIBER_CAMPAIGN_CREATE_PRIVILEGE: 'RECURRING_VIBER_CAMPAIGN_CREATE_PRIVILEGE',
    RECURRING_VIBER_CAMPAIGN_UPDATE_PRIVILEGE: 'RECURRING_VIBER_CAMPAIGN_UPDATE_PRIVILEGE',
    RECURRING_VIBER_CAMPAIGN_DELETE_PRIVILEGE: 'RECURRING_VIBER_CAMPAIGN_DELETE_PRIVILEGE',
    RECURRING_SMS_CAMPAIGN_READ_PRIVILEGE: 'RECURRING_SMS_CAMPAIGN_READ_PRIVILEGE',
    RECURRING_SMS_CAMPAIGN_CREATE_PRIVILEGE: 'RECURRING_SMS_CAMPAIGN_CREATE_PRIVILEGE',
    RECURRING_SMS_CAMPAIGN_UPDATE_PRIVILEGE: 'RECURRING_SMS_CAMPAIGN_UPDATE_PRIVILEGE',
    RECURRING_SMS_CAMPAIGN_DELETE_PRIVILEGE: 'RECURRING_SMS_CAMPAIGN_DELETE_PRIVILEGE',
    TRANSACTIONAL_VIBER_READ_PRIVILEGE: 'TRANSACTIONAL_VIBER_READ_PRIVILEGE',
    TRANSACTIONAL_SMS_READ_PRIVILEGE: 'TRANSACTIONAL_SMS_READ_PRIVILEGE',
    TESTLIST_READ_PRIVILEGE: 'TESTLIST_READ_PRIVILEGE',
    TESTLIST_CREATE_PRIVILEGE: 'TESTLIST_CREATE_PRIVILEGE',
    TESTLIST_UPDATE_PRIVILEGE: 'TESTLIST_UPDATE_PRIVILEGE',
    TESTLIST_DELETE_PRIVILEGE: 'TESTLIST_DELETE_PRIVILEGE',
    ERROR_READ_PRIVILEGE: 'ERROR_READ_PRIVILEGE'
}
export const ROLES = {
    USER: 'ROLE_USER',
    ADMIN: 'ROLE_ADMIN',
    SUPER_ADMIN: 'ROLE_SUPER_ADMIN'
}

export const MSG_STATUS_COLORS = {
    OVERCHARLIMIT: '#CC221A',
    UNDELIVERED: '#FF2B2B',
    FAILED: '#AA3333',
    EXPIRED: '#FF6600',
    SYNTAX: '#FF8011',
    INVALID: '#FF4400',
    SEEN: '#00BD4B',
    DELIVERED: '#028537',
    UPLOADED: '#176C97',
    SUBMITTED: '#188396',
    QUEUED: '#176C80'
}

export const VIBER_STATUS_LABELS = [
    'FAILED',
    'EXPIRED',
    'QUEUED',
    'UNDELIVERED',
    'DELIVERED',
    'SEEN',
    'OVERCHARLIMIT',
    'SYNTAX',
    'UPLOADED',
    'SUBMITTED'
]

export const SMS_STATUS_LABELS = [
    'OVERCHARLIMIT',
    'SYNTAX',
    'INVALID',
    'UNDELIVERED',
    'DELIVERED',
    'SUBMITTED',
    'UPLOADED'
]

export const MESSAGE_TYPES = [
    'ONESHOT',
    'RECURRING',
    'TRANSACTIONAL'
]
